import React, { useEffect, useMemo, useState } from 'react';
import { useUserProfile } from '../masterLayout/MasterLayoutBody';
import StockItemStatusLayer from './StockItemStatusLayer';
import RepairStatusLayer from './RepairStatusLayer';
import ComponentTypeLayer from './ComponentTypeLayer';
import PartsCriticalityLayer from './PartsCriticalityLayer';
import PartsCategoryLayer from './PartsCategoryLayer';
import HazardClassLayer from './HazardClassLayer';

const PurchasingInventoryReferencesLayer = () => {
  const userProfile = useUserProfile();

  const tabs = useMemo(() => {
    const items = [];

    if (userProfile?.privileges?.includes('stock-item-status:view')) {
      items.push({ key: 'stock-item-status', label: 'Stock Item Status', Component: StockItemStatusLayer });
    }

    if (userProfile?.privileges?.includes('repair-status:view')) {
      items.push({ key: 'repair-status', label: 'Rotable Repair Status', Component: RepairStatusLayer });
    }

    if (userProfile?.privileges?.includes('component-type:view')) {
      items.push({ key: 'component-type', label: 'Component Type', Component: ComponentTypeLayer });
    }

    if (userProfile?.privileges?.includes('parts-criticality:view')) {
      items.push({ key: 'parts-criticality', label: 'Part Criticality', Component: PartsCriticalityLayer });
    }

    if (userProfile?.privileges?.includes('parts-category:view')) {
      items.push({ key: 'parts-category', label: 'Part Category', Component: PartsCategoryLayer });
    }

    if (userProfile?.privileges?.includes('hazard-class:view')) {
      items.push({ key: 'hazard-class', label: 'Hazard Class', Component: HazardClassLayer });
    }

    return items;
  }, [userProfile]);

  const [activeTab, setActiveTab] = useState(null);

  useEffect(() => {
    if (!activeTab && tabs.length > 0) {
      setActiveTab(tabs[0].key);
    } else if (activeTab && !tabs.find((tab) => tab.key === activeTab) && tabs.length > 0) {
      setActiveTab(tabs[0].key);
    }
  }, [tabs, activeTab]);

  if (!tabs.length) {
    return (
      <div className='card h-100 p-0 rounded-0'>
        <div className='card-body d-flex align-items-center justify-content-center'>
          <p className='mb-0'>You do not have access to view these tables.</p>
        </div>
      </div>
    );
  }

  const ActiveComponent = tabs.find((t) => t.key === activeTab)?.Component || tabs[0].Component;

  return (
    <div className='card h-100 p-0 rounded-0 overflow-hidden'>
      <div className='card-body p-0'>
        <ul className='nav nav-tabs mb-3'>
          {tabs.map((t) => (
            <li key={t.key} className='nav-item'>
              <button
                className={`nav-link ${activeTab === t.key ? 'active' : ''}`}
                onClick={() => setActiveTab(t.key)}
              >
                {t.label}
              </button>
            </li>
          ))}
        </ul>
        <ActiveComponent />
      </div>
    </div>
  );
};

export default PurchasingInventoryReferencesLayer;
